import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { SubscriptionManager } from "@ramudden/core/utils";
import { MetaApi } from "@ramudden/data-access/resource/meta.api";
import { IHealthCheck } from "@ramudden/models/health-check";
import { ErrorService, WebsiteService } from "@ramudden/services";
import { interval } from "rxjs";
import { ContentDefaultComponent } from "../../layout/content/content-default/content-default.component";
import { SharedModule } from "../../shared/shared.module";

@Component({
    selector: "app-service-status",
    templateUrl: "./service-status.component.html",
    styleUrls: ["./service-status.component.scss"],
    imports: [SharedModule, ContentDefaultComponent],
    standalone: true,
})
export class ServiceStatusComponent implements OnInit, OnDestroy {
    private static readonly POLL_TIME_SECONDS = 10;

    private readonly subscriptionManager = new SubscriptionManager();
    pollTimer: number;
    online: boolean;

    private readonly metaApi = inject(MetaApi);
    private readonly errorService = inject(ErrorService);
    protected readonly websiteService = inject(WebsiteService);

    healthCheck?: IHealthCheck;

    ngOnInit() {
        // Instantly try to reconnect
        this.resetTimer(1);

        const onCheckOk = (healthCheck: IHealthCheck) => {
            this.healthCheck = healthCheck;

            if (healthCheck.status === "Healthy") {
                window.location.href = this.errorService.getPreviousAvailablePageAsRawWebsiteUrl();
            } else {
                this.resetTimer();
            }
        };

        const onError = (err: any) => {
            if (err?.error && typeof err.error === "string") {
                try {
                    this.healthCheck = JSON.parse(err.error) as IHealthCheck;
                } catch {
                    this.healthCheck = null;
                }
            }
            this.resetTimer();
        };

        const pollTimerSubscription = interval(1000).subscribe(() => {
            if (this.pollTimer === 0) return;

            this.pollTimer--;

            if (this.pollTimer === 0) {
                this.metaApi.getHealthCheck$().subscribe({
                    next: onCheckOk,
                    error: onError,
                });
            }
        });

        this.subscriptionManager.add("pollTimerSubscription", pollTimerSubscription);
    }

    ngOnDestroy() {
        this.subscriptionManager.clear();
    }

    private resetTimer(timer = ServiceStatusComponent.POLL_TIME_SECONDS) {
        console.clear();
        this.errorService.clearErrors();
        this.pollTimer = timer;
        this.online = window.navigator.onLine;
    }
}
